import { BillExtent } from '@mews-commander/data-access';

export const BILL_DETAIL_EXTENT: BillExtent = {
    orderItems: true,
    products: true,
    serviceOrders: true,
    services: true,
    billProfiles: true,
    correctedBills: true,
    notes: false,
    paymentCards: false,
    paymentProfiles: false,
    payments: false,
    associatedBills: false,
    cashiers: false,
};
